import { render, staticRenderFns } from "./moneyForDetails.vue?vue&type=template&id=31b0db0a&scoped=true&"
import script from "./moneyForDetails.vue?vue&type=script&lang=js&"
export * from "./moneyForDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0db0a",
  null
  
)

export default component.exports